export enum QaState {
  integrated = 'integrated',
  internalQa = 'internalQa',
  externalQa = 'externalQa'
}
